import React, { Component } from 'react'
import Herosection from '../Components/Hero_section';
import Section from '../Components/Section';
// import axios from 'axios';

export default class Home extends Component {

  render() {
  
    return (
      <div>
        <Herosection />
        {/* <Section title="Case studies" subtitle="I LOVE"/> */}
        <Section title="Ux design" subtitle="I LOVE"/>
        <Section title="Ui design" subtitle="I LOVE"/>
        <Section title="Development" subtitle="I LOVE"/>
        <Section title="Graphic design" subtitle="I LOVE"/>
      </div>
    )
  }
}